const getImageLink = (text)=>{
    var regExp =/([a-z\-_0-9\/\:\.]*\.(jpg|jpeg|png|gif))/i;
    var match = text.match(regExp);
    return (match)? match[1] : null;
};

export default getImageLink;